import React from 'react';

import { StyledEventSliderSkeleton } from './eventSlider.style';
import { StyledSliderControlsSkeleton } from '../../molecules/slider-controls/sliderControls.style';
import Container from '../../layout/container/container';

const EventSliderSkeleton = () => (
  <StyledEventSliderSkeleton>
    <Container>
      <div className="skeleton__headline" />
      <div className="skeleton-wrapper">
        <div className="skeleton-wrapper__item" />
        <div className="skeleton-wrapper__item" />
        <div className="skeleton-wrapper__item" />
        <div className="skeleton-wrapper__item" />
      </div>
      <StyledSliderControlsSkeleton />
    </Container>
  </StyledEventSliderSkeleton>
);

export default EventSliderSkeleton;
